import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=30cb3251&scoped=true"
import script from "./SubmitButton.vue?vue&type=script&lang=js"
export * from "./SubmitButton.vue?vue&type=script&lang=js"
import style0 from "./SubmitButton.vue?vue&type=style&index=0&id=30cb3251&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cb3251",
  null
  
)

export default component.exports